import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DescriptionDropdownComponent } from './description-dropdown.component';

// Its own module (rather than declared in SharedModule) so pages that SharedModule itself imports - like the
// time and billing create page - can use the dropdown without a circular import.
@NgModule({
  declarations: [DescriptionDropdownComponent],
  imports: [CommonModule],
  exports: [DescriptionDropdownComponent]
})
export class DescriptionDropdownModule { }
